import React, { Component } from 'react';
import { array, bool, object } from 'prop-types';
import moment from 'moment';

import AttachmentsList from '../Attachments';
import Message from '../Message';
import Disclaimer from '../Disclaimer';
import LoadingState from '../LoadingState';

import cx from 'classnames';
import s from './MessagesList.css';


// Receives messages state array from parent.
export default class MessagesList extends Component {
    static propTypes = {
        error: object,
        isLoadingAllMessages: bool,
        messagesList: array.isRequired,
    };

    // Only scroll to the bottom on initial message load and if Patient replies.
    componentDidUpdate(prevProps) {
        const { isLoadingAllMessages } = prevProps;

        if (isLoadingAllMessages || this.props.messagesList !== prevProps.messagesList) {
            const objDiv = document.getElementById('messagesList');
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }

    // Technically, we should always have 1 message from the practice. This is set to render a default in case we don't.
    renderMessages = () => {
        const { isLoadingAllMessages, messagesList } = this.props;
        let messages;

        // Loading...
        if (isLoadingAllMessages) {
            return messages =
                <section className={cx(s.loadingState, s.componentLoading)}>
                    <p>Loading conversation...</p>
                    <LoadingState context="messagesList" />
                </section>;
        }
        // Found messages. Loop and return a Message.
        else if (messagesList.length >= 1) {
            messages = messagesList.map((message, i) => {
                const dateTimeSent = moment(message.dateTimeSent).format("MMMM Do, h:mm a");
                const fromPatientCss = message.fromPatient ? s.fromPatient : '';
                const messageContent = message.message || '';
                const id = message.id;

                return (
                    <article
                        key={i}
                        className={cx(s.messageContainer, fromPatientCss)}
                        id={`message-${id}`}
                    >
                        <Message
                            dateTimeSent={dateTimeSent}
                            fromPatient={message.fromPatient}
                            message={messageContent}
                            userName={message.name}
                        />
                        <AttachmentsList
                            attachments={message.attachments}
                            fromPatient={message.fromPatient}
                        />
                    </article>
                );
            });

            return messages;
        }
        // return null. API failure ui is handled in <Chat />
        else {
            return messages = null;
        }
    };

    render = () => {
        const messages = this.renderMessages();
        const { error } = this.props;

        return (
            <section className={s.component} id="messagesList">
                {!error && messages !== null &&
                    <Disclaimer />
                }
                {messages}
            </section>
        );
    }
}
